import { Injectable } from '@angular/core';
import { PerformerProfileDto } from '@app/modules/account-modules/performers.model';

/**
 * Service for passing performer page preview data between components.
 * Data in PerformerProfileDto format is set before navigating to the preview page and read there.
 */
@Injectable({ providedIn: 'root' })
export class PerformersPreviewService {
  private previewData: PerformerProfileDto | null = null;

  setPreviewData(data: PerformerProfileDto): void {
    this.previewData = data;
  }

  getPreviewData(): PerformerProfileDto | null {
    const data = this.previewData;
    this.previewData = null;
    return data;
  }
}
